'use client';
import { useEffect } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
export default function AppInsightsClient() {
  useEffect(() => {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: process.env.NEXT_PUBLIC_APPLICATIONINSIGHTS_CONNECTION_STRING,
        enableAutoRouteTracking: true, 
        disableCookiesUsage: false,    
      }
    });
    
    appInsights.loadAppInsights();
    
    console.log('[AppInsights] Client SDK Initialized');
  }, []);
  return null;
}